(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["th-home-carousel"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('tonsor-carousel')){
 customElements.define('tonsor-carousel',class extends HTMLElement{
  connectedCallback(){
   if(this.abort)return;
   this.abort=new AbortController();const o={signal:this.abort.signal};
   this.slides=Array.from(this.querySelectorAll('[data-slide]'));this.index=0;
   this.toggle=this.querySelector('[data-toggle]');this.count=this.querySelector('[data-count]');
   this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.editor=this.dataset.editor==='true';
   this.paused=this.dataset.autoplay!=='true'||this.motion.matches||this.editor||!!navigator.connection?.saveData||['slow-2g','2g'].includes(navigator.connection?.effectiveType);
   this.clean=this.dataset.clean==='true';this.visible=false;this.hovered=false;this.focused=false;this.host=this.closest('.thh-banner')||this;
   this.querySelector('[data-next]')?.addEventListener('click',()=>this.go(this.index+1,true),o);
   this.querySelector('[data-prev]')?.addEventListener('click',()=>this.go(this.index-1,true),o);
   this.toggle?.addEventListener('click',()=>{this.paused=!this.paused;this.explicitPlay=!this.paused;this.sync();},o);
   this.host.addEventListener('mouseenter',()=>{if(!this.clean){this.hovered=true;this.sync();}},o);
   this.host.addEventListener('mouseleave',()=>{this.hovered=false;this.explicitPlay=false;this.sync();},o);
   this.host.addEventListener('focusin',()=>{this.focused=true;this.sync();},o);
   this.host.addEventListener('focusout',e=>{if(!this.host.contains(e.relatedTarget)){this.focused=false;this.explicitPlay=false;this.sync();}},o);
   this.addEventListener('keydown',e=>{if(['ArrowLeft','ArrowRight','Home','End'].includes(e.key)){e.preventDefault();let i=e.key==='Home'?0:e.key==='End'?this.slides.length-1:this.index+(e.key==='ArrowRight'?1:-1);this.go(i,true);}},o);
   this.querySelector('.thc-track').addEventListener('pointerdown',e=>{this.touch=e.pointerType==='touch'?{x:e.clientX,y:e.clientY}:null;},o);
   this.querySelector('.thc-track').addEventListener('pointerup',e=>{if(this.touch){const dx=e.clientX-this.touch.x,dy=e.clientY-this.touch.y;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy))this.go(this.index+(dx<0?1:-1),true);this.touch=null;}},o);
   this.motion.addEventListener('change',()=>{if(this.motion.matches){this.paused=true;this.explicitPlay=false;}this.sync();},o);
   document.addEventListener('visibilitychange',()=>this.sync(),o);
   document.addEventListener('shopify:block:select',e=>{const i=this.slides.findIndex(s=>s.dataset.blockId===e.detail.blockId);if(i>=0){this.paused=true;this.go(i,true);}},o);
   const poster=this.querySelector('.thc-video-poster');this.posterReady=!poster;
   const openingPhoto=this.classList.contains('thc--hero')?this.slides[0]?.querySelector('picture img'):null;
   this.photoReady=!openingPhoto;
   if(openingPhoto){const ready=()=>{const show=()=>{if(this.isConnected){this.photoReady=true;this.sync();}};if(openingPhoto.decode)openingPhoto.decode().then(show,show);else show();};if(openingPhoto.complete)ready();else{openingPhoto.addEventListener('load',ready,{...o,once:true});openingPhoto.addEventListener('error',ready,{...o,once:true});}}
   if(poster){const ready=()=>{const paint=()=>requestAnimationFrame(()=>requestAnimationFrame(()=>{if(this.isConnected){this.posterReady=true;this.sync();}}));if(poster.decode)poster.decode().then(paint,paint);else paint();};if(poster.complete)ready();else{poster.addEventListener('load',ready,{...o,once:true});poster.addEventListener('error',ready,{...o,once:true});}}
   this.mount(this.slides[0]);
   this.observer=new IntersectionObserver(es=>{this.visible=es[0].isIntersecting;this.sync();},{threshold:.2});this.observer.observe(this);this.go(0);
  }
  mount(slide){
   if(!slide)return;
   const template=slide.querySelector('template[data-media]');
   if(template){slide.append(template.content.cloneNode(true));template.remove();}
   const v=slide.querySelector('video');
   if(v&&this.clean&&this.slides.length===1)v.loop=true;
   if(v&&!v.dataset.bound){v.dataset.bound='true';const o={signal:this.abort.signal};v.addEventListener('playing',()=>slide.setAttribute('data-video-ready',''),o);v.addEventListener('ended',()=>{if(this.slides[this.index]===slide)this.go(this.index+1);},o);v.addEventListener('error',()=>{slide.removeAttribute('data-video-ready');if(this.slides.length===1){this.paused=true;this.sync();}else if(!this.paused&&this.slides[this.index]===slide)this.go(this.index+1);},o);}
  }
  go(i,manual=false){
   this.index=(i+this.slides.length)%this.slides.length;this.mount(this.slides[this.index]);
   if(manual&&!this.clean){this.paused=true;this.explicitPlay=false;}
   this.slides.forEach((s,n)=>{const active=n===this.index;s.toggleAttribute('data-active',active);s.setAttribute('aria-hidden',String(!active));s.inert=!active;if(!active)s.querySelector('video')?.pause();});
   if(this.count){this.count.textContent=`${this.index+1} / ${this.slides.length}`;this.count.setAttribute('aria-live',manual?'polite':'off');}
   this.sync();
  }
  sync(){
   clearTimeout(this.timer);
   const v=this.slides[this.index]?.querySelector('video');
   const run=Boolean(this.posterReady&&this.photoReady&&!this.paused&&this.visible&&!document.hidden&&(!(this.hovered||this.focused)||this.explicitPlay));
   if(this.toggle){this.toggle.textContent=this.paused?this.toggle.dataset.play:this.toggle.dataset.pause;this.toggle.setAttribute('aria-pressed',String(this.paused));}
   this.dataset.running=String(run);
   if(!run){v?.pause();return;}
   if(this.slides.length>1&&!navigator.connection?.saveData)this.mount(this.slides[(this.index+1)%this.slides.length]);
   if(v){if(v.ended)v.currentTime=0;v.play().catch(()=>{this.paused=true;this.sync();});}
   else if(this.slides.length>1)this.timer=setTimeout(()=>this.go(this.index+1),Number(this.dataset.interval||6)*1000);
  }
  disconnectedCallback(){clearTimeout(this.timer);this.observer?.disconnect();this.abort?.abort();this.abort=null;this.querySelectorAll('video').forEach(v=>v.pause());}
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["th-home-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tonsor-photo-gallery')) {
  customElements.define('tonsor-photo-gallery', class extends HTMLElement {
    connectedCallback() {
      if(this.abort) return;
      this.track=this.querySelector('.thh-gallery__track');
      this.slides=Array.from(this.querySelectorAll('.thh-gallery__slide'));
      this.buttons=Array.from(this.querySelectorAll('button[data-direction]'));
      this.counter=this.querySelector('.thh-gallery__count');
      this.abort=new AbortController();
      const options={signal:this.abort.signal};
      this.buttons.forEach(b=>b.addEventListener('click',()=>this.move(Number(b.dataset.direction)),options));
      this.track.addEventListener('scroll',()=>this.update(),options);
      this.track.addEventListener('keydown',e=>{
        if(e.key==='ArrowRight'||e.key==='ArrowLeft') {e.preventDefault();this.move(e.key==='ArrowRight'?1:-1);}
      },options);
      this.update();
    }
    update(){
      this.current=Math.max(0,Math.min(this.slides.length-1,Math.round(this.track.scrollLeft/Math.max(1,this.track.clientWidth))));
      if(this.counter)this.counter.textContent=`${this.current+1} / ${this.slides.length}`;
      this.buttons.forEach(b=>b.disabled=Number(b.dataset.direction)<0?this.current===0:this.current===this.slides.length-1);
    }
    move(direction){
      const i=Math.max(0,Math.min(this.slides.length-1,this.current+direction));
      this.track.scrollTo({left:i*this.track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    }
    disconnectedCallback(){if(this.abort)this.abort.abort();this.abort=null;}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tonsor-navigation"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('tonsor-navigation'))customElements.define('tonsor-navigation',class extends HTMLElement{connectedCallback(){this.abort=new AbortController();const o={signal:this.abort.signal};this.addEventListener('keydown',e=>{if(e.key==='Escape'){const open=[...this.querySelectorAll('details[open]')].reverse()[0];if(open){open.open=false;open.querySelector('summary').focus();e.stopPropagation();e.preventDefault();}}},o);document.addEventListener('click',e=>{if(!this.contains(e.target))this.querySelectorAll('details[open]').forEach(d=>d.open=false);},o);this.addEventListener('focusout',e=>{if(e.relatedTarget && !this.contains(e.relatedTarget))this.querySelectorAll('details[open]').forEach(d=>d.open=false);},o);this.querySelectorAll('.tnav-group details').forEach(d=>d.addEventListener('toggle',()=>{if(d.open)this.querySelectorAll('.tnav-group details[open]').forEach(other=>{if(other!==d)other.open=false;});},o));}disconnectedCallback(){this.abort?.abort();}});
  } catch(e) { console.error(e); }
})();

})();
